module.exports = __webpack_public_path__ + "static/media/tyre-yellow-four2.d19e13c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-four2.png
// module id = 352
// module chunks = 0